import { api } from './api';

export const brandApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBrandByUserId: builder.query({
      query: (userId) => `/brands/user/${userId}`,
      providesTags: ['Brand'],
    }),
    updateBrandProfile: builder.mutation({
      query: ({ id, body }) => ({
        url: `/brands/profile/${id}`,
        method: 'PUT',
        body,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Brand'],
    }),
  }),
});

export const { useGetBrandByUserIdQuery, useUpdateBrandProfileMutation } = brandApi;
